'use client';

import { usePathname } from 'next/navigation';
import { ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, FontSizes, FontWeights, Text, units } from '@calm-web/design-system';

import { useAnalytics } from '@/hooks/analytics/useAnalytics';

const PageWrapper = styled.div`
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${palette('gray0')};
`;

const CardWrapper = styled.div`
	background-color: ${palette('white')};
	border-radius: ${units(2)};
	border: 1px solid ${palette('gray0')};
	padding: ${units(3)};
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${units(2)};
	width: fit-content;
`;

export default function NotFound(): ReactNode {
	const { logEvent } = useAnalytics();
	const pathname = usePathname();

	useEffect(() => {
		logEvent('404 Page : Viewed', { page_name: pathname ?? 'unknown' });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<PageWrapper>
			<CardWrapper>
				<Text
					el="h1"
					color="gray8"
					size={FontSizes.base}
					weight={FontWeights.Regular}
					align="center"
					noMargin
				>
					404 Page not found
				</Text>
				<Text el="p" color="gray8" size={FontSizes.sm} weight={FontWeights.Medium} align="center" noMargin>
					The link may be broken or outdated.
				</Text>
				<Button backgroundColor="blue3" href="/">
					Back to home
				</Button>
			</CardWrapper>
		</PageWrapper>
	);
}
